interface DauChartProps {
  series: readonly number[]
  labels: [string, string, string]
}

const W = 760
const H = 180

export function DauChart({ series, labels }: DauChartProps) {
  const min = Math.min(...series)
  const max = Math.max(...series)
  const range = max - min || 1

  const pointsArray = series.map((value, i) => {
    const x = (i / (series.length - 1)) * W
    const y = H - ((value - min) / range) * (H - 24) - 12
    return { x, y }
  })

  const polylinePoints = pointsArray.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ')
  const polygonPoints = `0,${H} ${polylinePoints} ${W},${H}`

  return (
    <div>
      <svg
        viewBox={`0 0 ${W} ${H}`}
        role="img"
        aria-label="Daily active users over the last 30 days"
        className="block h-auto w-full overflow-visible"
      >
        <defs>
          <linearGradient id="dau-chart-gradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="var(--fg)" stopOpacity="0.12" />
            <stop offset="100%" stopColor="var(--fg)" stopOpacity="0.0" />
          </linearGradient>
        </defs>

        {[0.25, 0.5, 0.75].map((fraction) => (
          <line
            key={fraction}
            x1="0"
            x2={W}
            y1={H * fraction}
            y2={H * fraction}
            className="stroke-border-strong"
            strokeWidth="1"
            strokeDasharray="4 4"
          />
        ))}

        <polygon points={polygonPoints} fill="url(#dau-chart-gradient)" />

        <polyline
          points={polylinePoints}
          fill="none"
          className="stroke-fg"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className="text-fg-subtle mt-3 flex justify-between text-sm tabular-nums">
        {labels.map((label) => (
          <span key={label}>{label}</span>
        ))}
      </div>
    </div>
  )
}
